import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report007Container from 'app/containers/Report/Report007'

const Report007PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_007)}</PageTitle>
      <Report007Container />
    </>
  )
}
const Report007Page = memo(Report007PageCpn, isEqual)

export default Report007Page
